export function Article({ article }) {
	return (
		<a href={article.permalink} className="steam-article" draggable="false">
			<div className="steam-article__image">
				{article.thumbnail_url ? (
					<img src={article.thumbnail_url} alt={article.post_title} />
				) : (
					<div className="steam-article__placeholder" />
				)}
			</div>

			<div className="steam-article__content">
				<div className="steam-article__categories">
					{article.categories.map((category) => (
						<span key={category}>{category}</span>
					))}
				</div>

				<span className="steam-article__title">{article.post_title}</span>
			</div>
		</a>
	);
}

export function Skeleton() {
	return <div className="steam-article__skeleton"></div>;
}
